import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import styled from 'styled-components';

const Slide = styled(Container)`
  height: 460px;
  position: relative;
  h1, h2 {
    font-family: 'IBM Plex Sans';
    font-style: italic;
    font-weight: 600;
    font-size: 46px;
    line-height: 130%;
    color: #4D99E5;
    margin-bottom: 18px;
  }
  p {
    font-family: 'IBM Plex Sans';
    font-weight: 400;
    font-size: 40px;
    line-height: 130%;
    color: #4D99E5;
    text-align: left;
    margin-bottom: 43px;
    max-width: 550px;
  }
  #text-col {
    z-index: 2;
    display: flex;
    align-items: start;
    justify-content: center;
    flex-direction: column;
    .row {
      width: 100%;
    }
  }
  #img-col {
    z-index: 1;
    height: 460px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    max-width: 100%;
    max-height: 120%;
  }
  @media only screen and (max-width: 1920px) {
    width: 100% !important;
    max-width: 100% !important;
  }
  @media only screen and (min-width: 1400px) and (max-width: 1920px) {
    padding: 0 8% 0 8%;
  }
  @media only screen and (max-width: 992px) {
    height: 520px;
    h1, h2 {
      font-size: 32px;
      margin-bottom: 15px;
    }
    p {
      font-size: 30px;
    }
    #img-col {
      height: 520px;
    }
  }
  @media only screen and (max-width: 768px) {
    padding: 20px 0 0;
    #img-col {
      height: auto;
    }
    h1, h2 {
      font-size: 26px;
      width: 100%;
      text-align: center;
    }
    p {
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      font-size: 26px;
      margin-bottom: 20px;
      padding: 0 10px;
    }
    img {
      width: 250px;
    }
  }
`;

const TransparentButton = styled.button`
  padding: 13px 48px;
  border: none;
  background: transparent;
  border-radius: 12px;
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 450;
  font-size: 29px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4D99E5;
  border: 3px solid #4D99E5;
  margin-bottom: 25px;
  transition: all 0.4s ease;
  :hover {
    background: #4D99E5;
    color: #FFF;
  }
  @media only screen and (max-width: 1150px) {
    font-size: 25px;
  }
  @media only screen and (max-width: 768px) {
    font-size: 20px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const KnowELabBanner = () => {
  return (
    <Slide>
      <Row>
        <Col xs={12} md={6} id='img-col'>
          <img src="https://firebasestorage.googleapis.com/v0/b/covid19-cc1fe.appspot.com/o/ecommerce%2FdoctorsSlider%2FphonMock.png?alt=media&token=ab834111-437f-495b-ab89-ae3ff17f5fca" alt="doctora" />
        </Col>
        <Col xs={12} md={6} id='text-col'>
          <h2>labopat.mx</h2>
          <p>Consulta el historial de tus pacientes cuando tú quieras.</p>
          <TransparentButton onClick={()=>window.location.href = '/registro'}>Crear cuenta</TransparentButton>
        </Col>
      </Row>
    </Slide>
  );
};
